import React, { useRef, useState } from "react";
import {
    Button,
    Menu,
    MenuItem,
    Stack,
    Typography,
} from "@mui/material";
import { Icons } from "./icons";

export const GetIP = ({ instances = [] }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedIp, setSelectedIp] = useState("");
    const menuTriggerRef = useRef(null);

    const open = Boolean(anchorEl);

    const handleClick = () => {
        setAnchorEl(menuTriggerRef.current);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleIpSelect = (ip) => {
        setSelectedIp(ip);
        handleClose();
    };

    const generateMenuItems = () => {
        const items = [];

        instances?.forEach((instance) => {
            instance?.ips?.forEach((ip, i) => {
                items.push(
                    <MenuItem
                        key={`${instance.id}-${i}`}
                        onClick={() => handleIpSelect(ip.addr)}
                    >
                        {instance.name} ({ip.network}) - {ip.addr}
                    </MenuItem>
                );
            });
        });

        return items.length > 0
            ? items
            : [<MenuItem key="no-data" disabled>No IPs Found</MenuItem>];
    };


    return (
        // <Stack spacing={0} marginTop={0}>
        //     {/* <Typography variant="h5" sx={{ color: "#BCBEC1 !important" }}> */}
        //         {/* Browse to various IP’s to get started */}
        //     {/* </Typography> */}

        //     <Button
        //         ref={menuTriggerRef}
        //         variant="contained"
        //         onClick={handleClick}
        //         endIcon={<Icons.downArrow />}
        //         sx={{ width: "fit-content", backgroundColor: "#002929" }}
        //     >
        //         Get IP Addresses
        //     </Button>

        //     <Menu
        //         anchorEl={anchorEl}
        //         open={open}
        //         onClose={handleClose}
        //         anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        //         transformOrigin={{ vertical: "top", horizontal: "left" }}
        //     >
        //         {generateMenuItems()}
        //     </Menu>

        //     {selectedIp && (
        //         <Typography variant="body1" mt={2}>
        //             Selected IP: <strong>{selectedIp}</strong>
        //         </Typography>
        //     )}
        // </Stack>

        <Stack
            spacing={0}
            sx={{
                position: "relative",
                p: 1,
                borderRadius: "10px",
                background: "rgba(0,0,0,0.2)",
                // backdropFilter: "blur(6px)",
                transition: "all 0.3s ease",
                "&:hover": {
                    background: "rgba(0,0,0,0.6)",
                }
            }}
        >
            {/* Hover text */}
            <Typography
                variant="body2"
                sx={{
                    color: "#BCBEC1",
                    opacity: 0,
                    maxHeight: 0,
                    overflow: "hidden",
                    transition: "all 0.3s ease",
                    mb: 0.5,

                    // 👇 hover pe show
                    ".MuiStack-root:hover &": {
                        opacity: 1,
                        maxHeight: "40px"
                    }
                }}
            >
                Browse to various IP’s to get started
            </Typography>

            {/* Button */}
            <Button
                ref={menuTriggerRef}
                variant="contained"
                onClick={handleClick}
                endIcon={<Icons.downArrow />}
                sx={{
                    width: "fit-content",
                    backgroundColor: "rgba(0, 41, 41, 0.4)",
                    backdropFilter: "blur(4px)",
                    color: "#fff",
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                    border: "1px solid rgba(255,255,255,0.1)",

                    "&:hover": {
                        backgroundColor: "#002929",
                    }
                }}
            >
                Get IP Addresses
            </Button>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
                {generateMenuItems()}
            </Menu>

            {selectedIp && (
                <Typography variant="body2" mt={1} sx={{ color: "#fff" }}>
                    Selected IP: <strong>{selectedIp}</strong>
                </Typography>
            )}
        </Stack>
    );
};